export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
}

let _config: FirebaseConfig | null = null;

export function setFirebaseConfig(config: FirebaseConfig): void {
  _config = config;
}

export function getFirebaseConfig(): FirebaseConfig {
  if (!_config) {
    throw new Error('Firebase config not loaded. Ensure setFirebaseConfig() is called in APP_INITIALIZER.');
  }
  return _config;
}